const eventData = [
    {
        id:4,
        en_title: 'Superannuation ceremony of Sri. Pratap Reddy, IPS',
        kn_title: 'ಶ್ರೀ. ಪ್ರತಾಪ್ ರೆಡ್ಡಿ, ಐಪಿಎಸ್ ಅವರ ಸೇವಾ ನಿವೃತ್ತಿ ಸಮಾರಂಭ',
        image:'/images/events/superannuation/e1.jpg',
        images:[
            {
                original: "/images/events/superannuation/e2.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_1.jpg",
              },
              {
                original: "/images/events/superannuation/e3.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_2.jpg",
              },
              {
                original: "/images/events/superannuation/e4.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_3.jpg",
              },
              {
                original: "/images/events/superannuation/e5.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_4.jpg",
              },
              {
                original: "/images/events/superannuation/e6.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_5.jpg",
              },
              {
                original: "/images/events/superannuation/e7.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_6.jpg",
              },
              {
                original: "/images/events/superannuation/e8.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_7.jpg",
              },
              {
                original: "/images/events/superannuation/e9.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
              },
            
                
            
        ]
       },

       {
        id:5,
        en_title: '78th Independence Day Celebration',
        kn_title: '78ನೇ ಸ್ವಾತಂತ್ರ್ಯ ದಿನಾಚರಣೆ',
        image:'/images/events/independence/i15.jpg',
        images:[
            {
                original: "/images/events/independence/i1.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_1.jpg",
              },
              {
                original: "/images/events/independence/i2.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_2.jpg",
              },
              {
                original: "/images/events/independence/i3.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_3.jpg",
              },
              {
                original: "/images/events/independence/i4.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_4.jpg",
              },
              {
                original: "/images/events/independence/i5.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_5.jpg",
              },
              {
                original: "/images/events/independence/i6.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_6.jpg",
              },
              {
                original: "/images/events/independence/i7.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_7.jpg",
              },
              {
                original: "/images/events/independence/i8.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
              },
              {
                original: "/images/events/independence/i9.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
              },
              {
                original: "/images/events/independence/i10.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
              },
              {
                original: "/images/events/independence/i11.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
              },
              {
                original: "/images/events/independence/i12.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
              },
              {
                original: "/images/events/independence/i13.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
              },
              {
                original: "/images/events/independence/i14.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
              },
              {
                original: "/images/events/independence/i15.jpg",
                thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
              },
            
                
            
        ]
       }
]
export default eventData